// @ts-ignore
import $ from "jquery";
import "slick-carousel";
import "./style.sass";
import { Page } from "./common/Page";
import { Newsletter } from "./newsletter/Newsletter";
var Index = /** @class */ (function () {
    function Index() {
        var _this = this;
        this.globalNavMenuWidth = 0;
        this.footerNavMenuWidth = 0;
        this.types = {
            newsletter: Newsletter
        };
        this.window = $(window);
        this.$el = $("html");
        this.mainEl = $("main");
        this.footerEl = $("footer");
        this.globalNav = $("nav#global-nav");
        this.footerNav = $("nav#footer-main-nav");
        this.initGlobalNav();
        this.initFooterNav();
        this.popup();
        $(document).ready(function () {
            _this.go();
        });
        $(window).resize(function () {
            _this.resize();
        });
        $(".compact-menu-toggle").on("click", function () {
            $("html").toggleClass("compact-menu-open");
        });
        $("#compact-menu").on("click", function (e) {
            if ($(e.target).is("#compact-menu")) {
                $("html").removeClass("compact-menu-open");
            }
        });
    }
    Index.prototype.popup = function () {
        var _this = this;
        if (window.pageData.popupShow) {
            this.popupCookie = window.pageData.popupCookie;
            var hasCookie = window.localStorage.getItem(this.popupCookie);
            if (!hasCookie) {
                $("html").addClass("popup-open");
                $("#popup .close-popup").on("click", function () { return _this.closePopup(); });
            }
        }
    };
    Index.prototype.closePopup = function () {
        $("html").removeClass("popup-open");
        window.localStorage.setItem(this.popupCookie, true);
    };
    Index.prototype.go = function () {
        var Controller = this.types[window.pageData.type];
        if (Controller) {
            new Controller;
        }
        else {
            new Page;
        }
        this.resize();
        $("html, body").addClass("go-loaded");
    };
    Index.prototype.resize = function () {
        this.windowWidth = this.window.width();
        this.windowHeight = this.window.height();
        this.footerHeight = this.footerEl.outerHeight();
        this.resizeGlobalNav();
        this.resizeFooterNav();
    };
    Index.prototype.initGlobalNav = function () {
        var _this = this;
        var links = this.globalNav.find("#nav-menu li");
        links.each(function (k, el) {
            var el = $(el);
            _this.globalNavMenuWidth += el.width();
        });
    };
    Index.prototype.initFooterNav = function () {
        var _this = this;
        var links = this.footerNav.find("li");
        links.each(function (k, el) {
            var el = $(el);
            _this.footerNavMenuWidth += el.width();
        });
    };
    Index.prototype.resizeGlobalNav = function () {
        $("html").removeClass("compact-menu-open");
        if (this.windowWidth < this.globalNavMenuWidth) {
            this.$el.addClass("compact-menu");
        }
        else {
            this.$el.removeClass("compact-menu");
        }
    };
    Index.prototype.resizeFooterNav = function () {
        if (this.windowWidth * 0.9 < this.footerNavMenuWidth) {
            this.$el.addClass("compact-footer-menu");
        }
        else {
            this.$el.removeClass("compact-footer-menu");
        }
    };
    return Index;
}());
new Index;
